import React from 'react';
import { useReplicate } from './ReplicateContext';

interface ReplicatePropertyCheckboxProps {
    property: string;
    label?: string;
}

export const ReplicatePropertyCheckbox: React.FC<
    ReplicatePropertyCheckboxProps
> = ({ property, label }) => {
    const { replicateMode, isPropertySelected, toggleProperty } =
        useReplicate();

    if (!replicateMode) {
        return null;
    }

    // Don't show replicate checkbox for the "order" property
    if (property === 'order') {
        return null;
    }

    return (
        <div className="flex items-center ml-2">
            <input
                type="checkbox"
                id={`replicate-${property}`}
                checked={isPropertySelected(property)}
                onChange={() => toggleProperty(property)}
                className="w-4 h-4 text-orange-600 bg-muted border-border rounded focus:ring-orange-500 focus:ring-2"
            />
            <label
                htmlFor={`replicate-${property}`}
                className="ml-1 text-xs text-orange-600 font-medium cursor-pointer"
                title={`Include ${label || property} in replication`}
            >
                Copy
            </label>
        </div>
    );
};
